// extracted by mini-css-extract-plugin
export default {"container":"styles_container__WwlX3","main_content":"styles_main_content__VucnX"};